import React from "react";
import { format, parse } from "date-fns";
import {
    BASIC_TIME_FORMAT,
    DAY_DATE_MONTH_YEAR_FORMAT,
    LONG_TIME_FORMAT,
    SHORT_DAY_DATE_MONTH_YEAR_FORMAT,
} from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import { IWorkshopSession } from "../../WorkshopSessions.interfaces";
import { useMultipleSessions } from "./MultipleSessions.utils";
import styles from "./MultipleSessions.module.scss";

const MultipleSessions = ({ sessions }: { sessions: IWorkshopSession[] }) => {
    useMultipleSessions({
        sessions,
    });

    return (
        <div className={styles.Wrapper}>
            {sessions.map((session, idx) => {
                const date = format(
                    parse(
                        session.startDate,
                        DAY_DATE_MONTH_YEAR_FORMAT,
                        new Date()
                    ),
                    SHORT_DAY_DATE_MONTH_YEAR_FORMAT
                );
                const startTime = format(
                    parse(session.startTime, BASIC_TIME_FORMAT, new Date()),
                    LONG_TIME_FORMAT
                );
                const endTime = format(
                    parse(session.endTime, BASIC_TIME_FORMAT, new Date()),
                    LONG_TIME_FORMAT
                );
                return (
                    <div className={styles.sessionContainer} key={session.uuid}>
                        <div className={styles.sessionStyle}>
                            {`Session ${idx + 1} -`}
                        </div>
                        <div className={styles.Date}>
                            {`${date} | ${startTime} - ${endTime}`}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MultipleSessions;
